import React from "react";
import styled from "@emotion/styled";
import { Color } from "../../utils/color";

import { ContainerWrapper } from "../wrapper/containerWrapper";
import { SectionHeading } from "../heading/sectionHeading";
import { CategoryWrapper } from "../wrapper/categoryWrapper";

export const ProductCategorySection = (props) => {
  return (
    <SSection>
      <ContainerWrapper>
        <SHeading data-heading-visible={props.visible}>
          <SectionHeading jp="カテゴリ一覧" en="Category" position="left" />
        </SHeading>
        <CategoryWrapper />
      </ContainerWrapper>
    </SSection>
  );
};

const SSection = styled.section`
  padding: 4rem 0;
  background-color: ${Color.light};
  /* ---------- */
  /* TB */
  @media screen and (max-width: 1023px) {
    width: 100%;
    padding: 2rem 0;
    .container {
      flex-direction: column;
    }
  }
  /* ---------- */
  /* TB */
  @media screen and (max-width: 599px) {
  }
`;

const SHeading = styled.div`
  margin-bottom: 4rem;
  /* ---------- */
  /* TB */
  @media screen and (max-width: 1023px) {
    margin-bottom: 2rem;
  }
  &[data-heading-visible="show"] {
    display: block;
  }
  &[data-heading-visible="hidden"] {
    display: none;
  }
`;
